// 所有的默认变量
export const Variables = {
  noData: "无数据 😢",

  name: {
    root: "JGantt",
    column: "JGanttColumn",
    slider: "JGanttSlider",
    table: "JTableContent",
    gantt: "JGanttContent",
    tableHeader: "JTableHeader",
    ganttHeader: "JGanttHeader",
    tableRow: "JContentTableRow",
    ganttRow: "JContentGanttRow",
    temporaryHeader:"temporaryHeader",
    temporaryRow:"temporaryRow"
  },

  key: {
    start: "start_date",
    end: "end_date",
    columnWidth: "columnWidth",
    showToday: "showToday",
    showWeekend: "showWeekend",
    header: "header",
    body: "body",
    todayColor: "todayColor",
    weekendColor: "weekendColor",
    bgColor: "bgColor",
    borderColor: "borderColor",
    textColor: "textColor",
    hoverRowColor: "hoverColor",
    selectRowColor: "selectColor"
  },

  size: {
    defaultHeaderHeight: 100,
    defaultMinHeaderHeight: 30,
    defaultContentRowHeight: 30,
    defaultMinContentRowHeight: 20,
    defaultMaxContentRowHeight: 70,
    defaultMinGanttColumnWidth: 18,
    defaultMaxGanttColumnWidth: 100,
    defaultTableColumnWidth: 120,
    defaultMinTableColumnWidth: 30
  },

  time: {
    millisecondOfDay: 86400000,
    millisecondOfWeek: 604800000
  }
};